var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiersSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8403 13.9219L19.6803 15.8419L12.0003 19.6819L4.32031 15.8419L8.16031 13.9219",
    stroke: "#FEB91E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8403 10.0781L19.6803 11.9981L12.0003 15.8381L4.32031 11.9981L8.16031 10.0781",
    stroke: "#FEB91E",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6803 8.16031L12.0003 12.0003L4.32031 8.16031L12.0003 4.32031L19.6803 8.16031Z",
    stroke: "#FEB91E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiersSvgrepoCom1);
export default __webpack_public_path__ + "static/media/tiers-svgrepo-com 1.eb95e7298800bb57881bb1cdfac6ca6f.svg";
export { ForwardRef as ReactComponent };